import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/composedReport/translations/TRANSLATION_KEYS'
import { MultiSelect } from 'legacy/lut/library/multiSelect'
import { FC, useCallback, useState } from 'react'

import { ICheckedValue } from 'core-components/library/list/types'

import { useSource } from '../../hooks/useSource'

import { values } from './configs'

interface IAmplifyMembershipMultiselectProps {
  onChange: (value: string[]) => void
  value: string[]
  className?: string
}

type TCheckValueTypes = 'full' | 'empty' | 'indeterminate'
export const AmplifyMembershipMultiselect: FC<IAmplifyMembershipMultiselectProps> = ({
  className,
  value,
  onChange,
}) => {
  const [checkedValues, setCheckedValues] = useState<ICheckedValue[]>([])

  const { source } = useSource({ data: values })

  const handleChange = useCallback(
    (value: string[]) => {
      onChange(value)
    },
    [onChange]
  )

  const onCheckWithChange = useCallback(
    (value: string[]) => {
      if (!value.length) {
        onChange(value)
        setCheckedValues([])
      }
    },
    [onChange]
  )

  const onCheck = useCallback(
    (item: Record<string, string>) => {
      setCheckedValues((state) => {
        const found = state.find((el) => el.key === item.value)
        if (found) {
          handleChange(value.filter((el) => el != item.value))
          return state.filter((el) => el.key !== found.key)
        }
        handleChange([...value, item.value])
        return [...state, { key: item.value, value: 'full' as TCheckValueTypes }]
      })
    },
    [value, handleChange]
  )

  return (
    <MultiSelect
      checkedValues={checkedValues}
      onCheck={onCheck}
      useRowCheckbox
      classes={{
        controlClasses: {
          root: className,
        },
      }}
      caption={'label'}
      source={source}
      value={value}
      onChange={onCheckWithChange}
      translation={TRANSLATION_KEYS.amplifyMembershipField}
    />
  )
}
